import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import defaultValues from '../../constant/defaultValues';

import { agreementPDF, getRegistrationLeadList, manageContacts } from '../../actions/memberAction';

import AcSimpleTable from "../../components/AcSimpleTable";
import InputField from '../../components/InputField';
import SubHeader from '../../components/SubHeader';

import { useAuth } from '../../AuthProvider';
import { hideLoading, showLoading } from "../../actions/loaderAction";
import { ToastContainer } from "react-toastify";
import { buildPath, convertUTCToTzDate, getPrefix, showErrorMessage, showSuccessMessage } from '../../utils/common';
import { capitalize, debounce, isEmpty, size } from 'lodash';
import ToolipsCustom from '../../components/ToolipsCustom';
import ButtonAdd from '../../components/ButtonAdd';
import axiosInstance from '../../axiosHttp';
import API_URL from '../../constant/api.config';
import { toExcel } from 'to-excel';
import LargePopupCertificate from '../../components/LargePopupCertificate';
import MediumPopup from '../../components/MediumPopup';
import { CKEditor } from "@ckeditor/ckeditor5-react";
import {
    ClassicEditor,
    Essentials,
    Bold,
    Italic,
    Underline,
    FontSize,
    Paragraph,
    List,
    Indent
} from "ckeditor5";
import errorMessages from '../../constant/errorMessages';
import LeadFilter from '../../components/memberFilter/LeadFilter';
import Emitter from '../../utils/Emitter';
import { privateRoutePaths } from '@/routes/private.route.config';


function ManageLeads(props) {

    const { admin, COMPANY_DEFAULTS } = defaultValues;
    const statusList = COMPANY_DEFAULTS.STATUS;
    const { user, isSuperAdmin, isPreKYCUser, isDemoUser, isEndUser, isViewer, isOpUser,  isInqUser, isAdmin } = useAuth();

    const [tableKey, setTableKey] = useState(0);
    const [memberList, setMemberList] = useState([]);
    const [offset, setOffset] = useState(admin.OFFSET);
    const [limit, setLimit] = useState(admin.LIMIT);
    const [searchTxt, setSearchTxt] = useState("");
    const [loading, setLoading] = useState(false);
    const [totalRows, settotalRows] = useState(0);
    const initialRef = useRef(true);
    const [columnName, setColumnName] = useState(admin.COLUMN_NAME);
    const [sortDirection, setSortDirection] = useState(admin.SORT_DIRECTION);
    const [current_page, setCurrentPage] = useState(1);
    const [nodata, setNoData] = useState(false);
    const [largemodalShow, setLargeModalShow] = useState(false);
    const [pdfUrl, setPdfUrl] = useState("");

    const [mediumModalShow, setMediumModalShow] = useState(false);
    const [selectedMemberId, setSelectedMemberId] = useState(null);
    const [contactDetail, setContactDetail] = useState("");
    const [errorContactDetail, setErrorContactDetail] = useState("");
    const [resetFilterFlag, setResetFilterFlag] = useState(false);
    const [statusValue, setStatusValue] = useState(-1);
    const [searchFilterObj, setFilterObj] = useState({
        offset: admin.OFFSET,
        limit: admin.LIMIT,
        columnName: admin.COLUMN_NAME,
        sortDirection: admin.SORT_DIRECTION,
        country: [],
        status_val: -1,
        table_search: "",
        trade_mode: []
    });

    // const getPrefix = () => {
    //     if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
    //     if (user && isDemoUser) return roles.DEMO.prefix;
    //     if (user && isEndUser) return roles.END_USER.prefix;
    //     if (user && isViewer) return roles.VIEWER.prefix;
    //     if (user && isOpUser) return roles.OPERATION_USER.prefix;

    //     return roles.SUPER_ADMIN.prefix;
    // };

    const columns = [
        {
            name: 'Sr No',
            selector: (row, idx) => {
                return (
                    <>{offset + (idx + 1)}</>
                )
            },
            width: "5%"
        },
        {
            name: 'Orex ID',
            selector: row => <div className='text-wrap'>{row.member_unique_number}</div>,
            width: "13%",
            columnName: 'member_unique_number',
            sortable: true
        },
        {
            name: 'Company Name',
            selector: row => <div className='text-wrap'>{row.company_name}</div>,
            width: "20%",
            columnName: 'company_name',
            sortable: true
        },
        {
            name: 'Trade Mode',
            selector: row => <div className='text-wrap'>{row.shipment_mode}</div>,
            width: "13%",
            columnName: 'shipment_mode',
            sortable: true
        },
        {
            name: 'Country',
            selector: row => <div className='text-wrap'>{row.country.name}</div>,
            width: "15%",
            columnName: "country_name",
            sortable: true
        },
        {
            name: 'Registration Date',
            selector: row => <div className='text-wrap'>{convertUTCToTzDate(row.created_at)}</div>,
            width: "19%",
            columnName: "created_at",
            sortable: true
        },

        {
            name: 'Actions',
            cell: (row) => (
                <>
                    {(user.role_slug.slug === "SUP_ADM" || isViewer || isOpUser || isInqUser) && <Link to={`/${getPrefix(user)}${buildPath(privateRoutePaths.UPDATE_COMPANY_PROFILE, { id: row.id + "?lead=" + btoa("WEB") })}`}>

                        <ToolipsCustom subtitle="Edit" className="fa-regular fa-pen-to-square icon-pen border-0 " classNameChild={"data-table-tooltiop"}></ToolipsCustom>
                    </Link>
                    }

                    <Link to={`/${getPrefix(user)}${buildPath(privateRoutePaths.VIEW_COMPANY_PROFILE, { id: row.id + "?lead=" + btoa("WEB") })}`}>

                        <ToolipsCustom subtitle="View" className="fa-regular fa-eye icon-eyes border-0 " classNameChild={"data-table-tooltiop"}></ToolipsCustom>
                    </Link>

                    {(isSuperAdmin || isOpUser || isAdmin) && row.trade_mode_type === 'LOG_PTR' && <ToolipsCustom
                        subtitle="Agreement PDF"
                        className="fa-regular fa-file-pdf border-0 panle-icon "
                        classNameChild={"data-table-tooltiop download-certificate"}
                        onClick={() => handleAgreementPDFClick(row.id)}
                    >
                    </ToolipsCustom>
                    }

                    {(user.role_slug.slug === "SUP_ADM" || user.role_slug.slug === "VIEWER") && <ToolipsCustom subtitle="Manage Contacts" className="fa fa-address-book icon-address-book border-0 " classNameChild={"data-table-tooltiop"} onClick={() => handleManageContactModal(row.id, row.additional_contacts)}></ToolipsCustom>}
                </>
            ),
            // Width: '10%'
        }
    ];

    const styleError = {
        display: "block",
    };

    const handleManageContactModal = (id, contact_details) => {

        setSelectedMemberId(id);
        setErrorContactDetail("");
        if (contact_details) {
            setContactDetail(contact_details.contact_detail);
        } else {
            setContactDetail("");
        }
        setMediumModalShow(true);
    }

    const validContactDetail = () => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = contactDetail;

        const trimmedText = tempDiv.textContent.trim();

        if (isEmpty(trimmedText)) {
            setErrorContactDetail(errorMessages.FIELD_REQUIRED)
            return false;
        }
        return true;
    }

    const AddContacts = async () => {

        if (await validContactDetail()) {
            let reqObj = {
                contact_detail: contactDetail
            }
            await props.manageContacts(reqObj, selectedMemberId).then((response) => {
                if (response.status === true) {
                    showSuccessMessage(response.message);
                    setSelectedMemberId(null);
                    setMediumModalShow(false);
                    getRegistrationLeadsMembers(offset, limit, current_page, columnName, sortDirection, searchTxt);
                }
            }).catch((err) => {
                console.log("Error ============= ", err);
            });
        }
    }


    const handleAgreementPDFClick = async (id) => {
        props.showLoading();

        await props.pdfToAgreementMember(id).then((response) => {
            console.log("response", response);

            if (response.status === true) {

                const pdfUrl = response.data.pdf_url;

                setPdfUrl(pdfUrl);

                setLargeModalShow(true);
                props.hideLoading();


            } else {
                console.log("False", response);
                showErrorMessage("Something went wrong!");
            }


        }).catch((err) => {
            console.log("Error ==== ", err);
            showErrorMessage("Something went wrong!");
        });
        props.hideLoading();
    }

    const handleSort = async (column, sortDirection) => {
        setColumnName(column.columnName);
        setSortDirection(sortDirection);
        // getRegistrationLeadsMembers(
        //     admin.OFFSET,
        //     admin.LIMIT,
        //     current_page,
        //     column.columnName,
        //     sortDirection,
        //     searchTxt
        // );
        getRegistrationLeadsMembers(
            offset,
            limit,
            current_page,
            column.columnName,
            sortDirection,
            searchTxt
        );
    };

    const onSearchTextBoxChanged = debounce((e) => {
        setSearchTxt(e.target.value);
        let searchVal = e.target.value;
        if (searchVal.length >= 3 || searchVal.length === 0) {
            setOffset(admin.OFFSET);
            setLimit(admin.LIMIT);
            setColumnName(admin.COLUMN_NAME);
            setSortDirection(admin.SORT_DIRECTION);
            setCurrentPage(1);
            setTableKey((prev) => prev + 1);
            getRegistrationLeadsMembers(admin.OFFSET, admin.LIMIT, 1, admin.COLUMN_NAME, admin.SORT_DIRECTION, e.target.value);
        }

    });


    const getRegistrationLeadsMembers = async (offset, limit, current_page = 1, columnName = "created_at", sortDirection = "DESC", searchTxt = null) => {
        setNoData(false);
        await props.showLoading();
        let fObj = { ...searchFilterObj };
        if (fObj !== undefined && fObj !== 0 && fObj !== null && fObj !== "") {
            let filterObj = {
                offset: offset,
                limit: limit,
                current_page: current_page,
                columnName: columnName,
                sortDirection: sortDirection,
                searchTxt: searchTxt,
                status_val: fObj.status_val,
                country: fObj.country,
                trade_mode: fObj.trade_mode
            }

            await props.getRegistrationLeads(filterObj).then((response) => {
                if (size(response.data) === 0) {
                    setNoData(true);
                }
                setMemberList(response.data);
                settotalRows(response.metadata.total);
            }).catch((err) => {
                console.log("Error ==== ", err);
                showErrorMessage("Something went wrong");
            })

        }
        await props.hideLoading();
    }

    useEffect(() => {
        if (initialRef.current === true) {
            initialRef.current = false;
            getRegistrationLeadsMembers(offset, limit, current_page, columnName, sortDirection, searchTxt);
        }
    }, []);


    const expandedRowComponent = ({ data }) => {
        const rowStatus = statusList.find(option => option.value === data.status);
        const statusLabel = rowStatus ? rowStatus.label : '';
        return (

            <div style={{ padding: '20px', borderTop: '1px solid #ddd' }}>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr 1fr',
                    gap: '22px',
                    padding: '12px',
                    border: '1px solid #ddd',
                    borderRadius: '8px'
                }}>
                    <div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Name:</strong> {(data.salutation ? data.salutation : '') + `  ` + (data.first_name ? data.first_name : '') + ` ` + (data.last_name ? data.last_name : '')}
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Email:</strong> {data.email || '-'}
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Plan Name:</strong> {(data.plan_name == null) ? "Free" : data.plan_name}
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Established Year:</strong> {data.establish_date || '-'}
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Status:</strong> {statusLabel}
                        </div>

                    </div>
                    <div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Phone:</strong> {data.phone || '-'}
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Country:</strong> {data.country.name || '-'}
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Company Size:</strong> {data.company_size || '-'}
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Trade Mode: </strong> {(data.shipment_mode) && data.shipment_mode} {(data.shipment_mode) && (data.shipment_mode === 'Manufacturer' || data.shipment_mode === 'Trader') ? '(' + capitalize(data.trade_mode_type) + ')' : ''}
                        </div>
                        {data.status === 4 && <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Reason:</strong> {data.reason || '-'}
                        </div>
                        }
                        {data.status != 4 && <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Designation:</strong> {data.designation || '-'}
                        </div>
                        }

                    </div>
                    <div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Mobile:</strong> {data.mobile || '-'}
                        </div>
                        {/* <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Designation:</strong> {data.designation || '-'}
                        </div> */}
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Industry:</strong> {data.member_industry ? data.member_industry.industy_name : "-"}
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>What You Want With Us:</strong> {data.with_us || '-'}
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Website:</strong> {data.website || '-'}
                        </div>
                        {data.status === 4 && <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Designation:</strong> {data.designation || '-'}
                        </div>
                        }
                    </div>
                </div>
            </div>
        );
    };

    const handleExport = () => {
        showErrorMessage("Something Went Wrong!!");
        return;
        /* const headers = setAuthHeaders();

        axiosInstance
            .get(API_URL + "/export-registration-lead-list", { headers })
            .then((response) => {

                var data = response.data.data;
                var headers = response.data.headers;

                const now = new Date();
                const year = now.getFullYear();
                const month = String(now.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
                const day = String(now.getDate()).padStart(2, '0');
                const hours = String(now.getHours()).padStart(2, '0');
                const minutes = String(now.getMinutes()).padStart(2, '0');
                const seconds = String(now.getSeconds()).padStart(2, '0');

                const formattedDate = `${year}-${month}-${day}_${hours}_${minutes}_${seconds}`;

                toExcel.exportXLS(headers, data, 'Orex_Leads_' + formattedDate);
            }).catch((err) => {
                console.log("Error ==== ", err);
            });*/
    }

    const setLeadFilters = (newState) => {

        newState.table_search = "";
        setLimit(newState.limit);
        setOffset(newState.offset);
        setCurrentPage(newState.current_page);
        setFilterObj(newState);
        setTableKey((prev) => prev + 1);
    }

    const filterApplyOnLeads = (filterObj) => {
        getRegistrationLeadsMembers(offset, limit, current_page, columnName, sortDirection, searchTxt);
    }


    useEffect(() => {
        // Emitter.on("FILTER_MEMBERS", filterMemberData);
        Emitter.on("FILTER_LEADS", filterApplyOnLeads);
        Emitter.on("SET_FILTER_LEADS", setLeadFilters);
        return () => {
            Emitter.off("FILTER_LEADS", filterApplyOnLeads);
        };
    });


    return (<>

        <div className='data-table-main'>
            <div className="AcSimpleTable">

                <SubHeader layer1="Lead Management" layer2="List" layer3=""
                    pageName="Registration Leads"
                    clickable={{
                        layer1: "",
                        layer2: "",
                        layer3: ""
                    }}
                />

                <div className='filter-section'>
                    <LeadFilter />
                </div>

                <div className='card1'>

                    <div className='table-header-name manage-leads-wrap'>
                        <h5 className='table-text py-3'>List</h5>
                        <div className='d-flex justify-content-between align-items-center py-3'>
                            {(isSuperAdmin) && (
                                <ButtonAdd className='export-btn ms-2' type="button" onClick={handleExport}>
                                    <i className="fa-solid fa-upload"></i> Export
                                </ButtonAdd>
                            )}

                            <label className='mx-3'>Search</label>
                            <InputField
                                type="text"
                                id="filter-text-box"
                                placeholder="Search..."
                                className='w-25'
                                onKeyUp={onSearchTextBoxChanged}
                                autoComplete="off"
                            ></InputField>

                        </div>

                    </div>

                    <div className="table-wrapper">
                        <div className="table-container">
                            {memberList && (
                                <AcSimpleTable
                                    key={tableKey}
                                    data={memberList}
                                    title=""
                                    listTitle="manageLeads"
                                    pagination={true}
                                    paginationPageSize={limit}
                                    columns={columns}
                                    progressPending={loading}
                                    paginationTotalRows={totalRows}
                                    fixedColumnsStart={admin.FIXED_COLUMNS_START}
                                    getData={getRegistrationLeadsMembers}
                                    offset={offset}
                                    limit={limit}
                                    columnName={columnName}
                                    sortDirection={sortDirection}
                                    setLimit={setLimit}
                                    setOffset={setOffset}
                                    setColumnName={setColumnName}
                                    setSortDirection={setSortDirection}
                                    setLoading={setLoading}
                                    // noDataComponent={<NoData />}
                                    paginationPerPage={limit}
                                    paginationRowsPerPageOptions={admin.PAGINATE_RANGE}
                                    // className="company-table"
                                    striped
                                    sortServer
                                    onSort={handleSort}
                                    defaultSortAsc={false}
                                    current_page={current_page}
                                    setCurrentPage={setCurrentPage}
                                    expandableRows
                                    expandableRowsComponent={expandedRowComponent}
                                    noData={nodata}
                                    searchTxt={searchTxt}
                                />
                            )}
                        </div>
                    </div>
                </div>


            </div>
            <LargePopupCertificate
                LargeModalShow={largemodalShow}
                setLargeModalShow={setLargeModalShow}
                pdfUrl={pdfUrl}
            ></LargePopupCertificate>

            <MediumPopup
                mediummodalShow={mediumModalShow}
                setMediumModalShow={setMediumModalShow}
                type="submit"
                onSubmit={AddContacts}
                okButtonLabel="Add"
                closeButtonLabel="Cancel"
                title="Manage Contacts"
            >
                <CKEditor
                    key={`member_${selectedMemberId}`}
                    editor={ClassicEditor}
                    data={contactDetail || ''}
                    config={{
                        toolbar: {
                            items: ['bold', 'italic', 'underline', 'fontSize', 'bulletedList', 'outdent', 'indent'],
                        },
                        fontSize: {
                            options: [10, 12, 14, 'default', 18, 20, 22, 24, 30],
                            supportAllValues: false,
                        },
                        language: 'en',
                        plugins: [
                            Essentials,
                            Bold,
                            Italic,
                            Underline,
                            FontSize,
                            Paragraph,
                            List,
                            Indent
                        ],
                        licenseKey: "GPL",
                        // licenseKey: "",

                    }}
                    onChange={(event, editor) => {
                        const data = editor.getData();
                        setContactDetail(data);
                    }}
                    onReady={(editor) => {
                        editor.editing.view.change((writer) => {
                            writer.setStyle(
                                "height",
                                "150px",
                                editor.editing.view.document.getRoot()
                            );
                            writer.setStyle(
                                "width",
                                "100",
                                editor.editing.view.document.getRoot()
                            );
                        });
                    }}
                    onBlur={(event, editor) => {
                        const data2 = editor.getData();
                        const tempDiv = document.createElement("div");
                        tempDiv.innerHTML = data2;

                        const trimmedText = tempDiv.textContent.trim();

                        if (isEmpty(trimmedText)) {
                            setErrorContactDetail(errorMessages.FIELD_REQUIRED);
                        } else {
                            setErrorContactDetail("");
                        }
                    }}
                />
                {errorContactDetail &&
                    <div className="company-required-content" style={styleError}>
                        {" "}
                        {errorContactDetail}
                    </div>
                }


            </MediumPopup>

            {/* <ToastContainer /> */}
        </div>

    </>)
}

const mapStateToProps = state => {

    return {
        member_list: state.member.pendingMemberlist,
        // authError: state.auth.errorMessages
    }
}
const mapDispatchToProps = dispatch => {
    return {
        getRegistrationLeads: (filterObj) => dispatch(getRegistrationLeadList(filterObj)),
        showLoading: () => dispatch(showLoading()),
        hideLoading: () => dispatch(hideLoading()),
        pdfToAgreementMember: (id) => dispatch(agreementPDF(id)),
        manageContacts: (data, member_id) => dispatch(manageContacts(data, member_id))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageLeads);
